import "./style.scss";
import logoCompany from "../../src/assets/logo_company.jpg";

const CURRENT_WEB_CHAT =
    process.env.REACT_APP_CURRENT_WEB_CHAT ||
    "http://winitechvina.iptime.org/chat";

const pushNotification = (content, conversationId, languageMap) => {
  const options = {
    body: content,
    icon: logoCompany,
    actions: [
      {
        action: "view",
        title: languageMap?.["message.notification.content.view"] ?? "View",
      },
    ],
    data: {
      url: CURRENT_WEB_CHAT + (conversationId ? `/${conversationId}` : ""),
    },
  };

  if (content && Notification.permission === "granted") {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification("WillO", options);
    });

  }
};
export {
  pushNotification
};
